import { useEffect } from "react";
import { Outlet, useNavigate } from "react-router";
import { useGetUserDetailsQuery } from "features/api/userApi.ts";
import { LegalLinks, TopNavigationBar } from "components";
import { LandingPageContainer, LandingPageSubContainer } from "./landingPage.styles";
import DialogManager from "../../components/Dialog/components/DialogManager.tsx";
import { useUserLocation } from "hooks/useUserLocation.ts";
import { UserNavigationGroup, UserRole } from "types/declarations/enums.ts";

const LandingPage = () => {
	const navigateToRedirects = useNavigate();
	const { isMainLandingPage } = useUserLocation();

	const { data: userDetails, isLoading, refetch } = useGetUserDetailsQuery();

	useEffect(() => {
		if (refetch === undefined) return;
		refetch();
	}, [refetch]);

	useEffect(() => {
		if (!userDetails || !isMainLandingPage) return;

		const destination =
			userDetails.role === UserRole.QUOTER || userDetails.navigationGroup === UserNavigationGroup.QUOTER
				? "/custom-quote"
				: "/projects";
		navigateToRedirects(destination);
	}, [userDetails, navigateToRedirects, isMainLandingPage]);

	if (!isMainLandingPage && !isLoading) {
		return (
			<LandingPageContainer data-testid="tandem-landing-page">
				<DialogManager />
				<TopNavigationBar userDetails={userDetails} />
				<LandingPageSubContainer
					maxWidth={false}
					disableGutters
				>
					<Outlet />
					<LegalLinks />
				</LandingPageSubContainer>
			</LandingPageContainer>
		);
	}
	return null;
};

export default LandingPage;
